import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Checkbox, Row, Col, Radio } from 'antd';

import { propertyFacilityTechnologyCategory } from 'common/constants/property';

export default class Facilities extends React.Component {
  constructor(props) {
    super(props);
  }

  handleFormChange = (item, group) => {
    const { value } = this.props;

    const newFacilities = value?.map(facility => {
      if (facility.checked !== item.value) {
        if (item.slug === facility.slug) {
          if (item.value) {
            return {
              ...facility,
              slug: facility.slug,
              label: facility.label,
              checked: true,
            };
          }
          return {
            ...facility,
            slug: facility.slug,
            label: facility.label,
            checked: false,
          };
        }
      }

      if (group && facility.group === group) {
        return {
          ...facility,
          slug: facility.slug,
          label: facility.label,
          checked: item.value === facility.slug,
        };
      }

      return facility;
    });

    this.props.onChange(newFacilities);
  };

  handleFormatValueOption = () => {
    const { value = [] } = this.props;

    const technologyCategory = propertyFacilityTechnologyCategory.map(
      slug => value?.find(item => item?.slug === slug) || {},
    );
    const radioKeys = value?.filter(item => item.group !== null) || [];
    const radioGroup = radioKeys?.[0]?.group || null;
    const checkBoxKeys =
      value?.filter(
        item =>
          item.group === null &&
          item.slug !== 'v2_unit_type_door_lock' &&
          !technologyCategory.some(cat => cat?.slug === item?.slug),
      ) || [];

    return {
      radioKeys,
      radioGroup,
      technologyCategory,
      checkBoxKeys,
    };
  };

  render() {
    const { t } = this.props;
    const { radioKeys, radioGroup, technologyCategory, checkBoxKeys } =
      this.handleFormatValueOption();

    return (
      <div className="facilities">
        <div className="content-title">
          <span className="content-title__text">
            {t('cms:cms.properties.edit.rooms.facilities')}
          </span>
        </div>

        <Row gutter={16}>
          {checkBoxKeys?.length > 0 &&
            checkBoxKeys.map(checkBoxItem => (
              <Col span={6} key={checkBoxItem.slug}>
                <Form.Item>
                  <Checkbox
                    onChange={e => {
                      this.handleFormChange({ value: e.target.checked, ...checkBoxItem });
                    }}
                    defaultChecked={checkBoxItem.checked}
                  >
                    {checkBoxItem.label}
                  </Checkbox>
                </Form.Item>
              </Col>
            ))}
        </Row>

        <div className="facilities__section">
          <span className="facilities__section-title">
            {t('cms:cms.properties.edit.rooms.facilities.technology')}
          </span>
        </div>

        <Row gutter={16}>
          {technologyCategory?.map(checkBoxItem => (
            <Col span={6} key={checkBoxItem?.slug}>
              <Form.Item>
                <Checkbox
                  onChange={e => {
                    this.handleFormChange({ value: e.target.checked, ...checkBoxItem });
                  }}
                  defaultChecked={checkBoxItem.checked}
                >
                  {checkBoxItem.label}
                </Checkbox>
              </Form.Item>
            </Col>
          ))}
        </Row>

        <div className="facilities__section">
          <span className="facilities__section-title">
            {t('cms:cms.properties.edit.rooms.facilities.meals')}
          </span>
        </div>

        <Row gutter={16}>
          <Form.Item>
            <Radio.Group
              onChange={e => {
                this.handleFormChange({ value: e.target.value }, radioGroup);
              }}
              defaultValue={radioKeys?.find(item => item.checked)?.slug}
            >
              {radioKeys.map(radioItem => (
                <Col span={6} key={radioItem.slug}>
                  <Radio value={radioItem.slug}>{radioItem.label}</Radio>
                </Col>
              ))}
            </Radio.Group>
          </Form.Item>
        </Row>
      </div>
    );
  }
}

Facilities.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

Facilities.defaultProps = {
  t: () => {},
  onChange: () => {},
};
